import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const EditableTemplateWrapper = styled.div<{
  whiteBackground?: boolean;
}>`
  width: 100%;

  .container-editable-template {
    display: flex;
    justify-content: start;
    align-items: start;
    width: 100%;
    flex-direction: column;
    overflow: visible;
    padding-bottom: 8px;
    gap: 8px;

    .email-subject-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      overflow: hidden;
      gap: 8px;
      .email-subject {
        display: flex;
        gap: 8px;
        align-items: center;
        width: 100%;
        font-size: 14px;
        color: ${colors.grey11};
        padding: 10px 16px;
        overflow: hidden;

        .email-subject-input {
          all: unset;
          color: ${colors.black};
          flex: 1;
          overflow: hidden;
        }
      }
    }

    .email-cc {
      display: flex;
      gap: 8px;
      align-items: center;
      width: 100%;
      font-size: 14px;
      color: ${colors.grey11};
      padding: 10px 16px;
    }
  }

  .add-variables-button {
    text-transform: unset;
    min-width: fit-content;
    white-space: nowrap;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
  }

  .template-editing-buttons {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 8px 8px 4px 8px;

    .cancel-changes-button {
      background: ${colors.grey6} !important;
      border-color: ${colors.grey33};

      &:hover {
        background: ${colors.grey444} !important;
      }
    }
  }

  .edit-zone {
    width: 100%;
    outline: none;
  }

  .toolbar-hidden {
    .ql-toolbar {
      display: none;
      visibility: hidden;
      opacity: 0;
    }
    .quill-editor {
      .ql-container {
        border-bottom: none !important;
      }
    }
    [data-slot='expandable-box-content']
      .quill-editor
      .ql-container
      .ql-editor {
      padding-bottom: 0;
    }
  }

  // Match Quill's own font-size and line-height so the collapsed box clips exactly one editor line.
  [data-slot='expandable-box'] {
    font-size: 13px;
    line-height: 1.42;
  }

  [data-slot='expandable-box-content'] {
    .ql-toolbar {
      // editor(1) - attachments(2) - toolbar(3)
      order: 3;
      border: none !important;
      background: ${(props) =>
        props.whiteBackground ? colors.white : colors.grey6};
      max-width: 78%;
      padding: 8px;
    }
    //In the editable template editor the toolbar is moved to the bottom, so we need to adjust the position of the create snippet
    #create-snippet-button {
      margin-top: -42px;
    }
    .quill-editor {
      .ql-container {
        width: 100%;
        border-radius: 0;
        border: none;
        border-bottom: 1px solid ${colors.grey3};

        .ql-editor {
          padding: 0 0 8px 0;
          overflow: hidden;
        }
      }
    }

    .variables-picker {
      top: -30px;
      bottom: unset;
    }

    .file-preview {
      padding: 10px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    .file {
      overflow: hidden;
      display: flex;
      align-items: center;
      height: 30px;
      background: ${colors.callScheduledLightHover};
      border-radius: 8px;
      padding: 8px;
    }
    .delete-attachments-icon {
      cursor: pointer;
    }
  }
`;

export const CcButton = styled.button`
  margin-left: 10px;
  font-weight: 500;
  margin-block: 0px;

  border: none;
  background: none;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  &:hover {
    color: ${colors.darkGreen};
  }
`;
